import React, { Component } from "react";

class LoadingIndicator extends Component {
  render() {
    return (
      <div className="loadingIndicator">
        <span>{this.props.text || "Loading"}</span>
      </div>
    );
  }
}
 
export default LoadingIndicator;